import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';

import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';

import moment from 'moment';
import TextField from '@material-ui/core/TextField';

import { withStyles } from '@material-ui/core/styles';

import Lang from '../modules/Lang';
import Preview from "./Preview";

import { formDataSubmit } from '../utils';
import { BASE_URL } from '../consts';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  dense: {
    marginTop: 19,
  },
  menu: {
    width: 200,
  },
  formControl: {
    // width: "50%"
  },  
  paper: {
    position: 'absolute',
    width: '90%',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
    outline: 'none',
    // margin: '50px',
  },
});

const thumbsContainer = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
}

const thumb = {
  display: 'inline-flex',
  borderRadius: 2,
  border: '1px solid #eaeaea',
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: 'border-box',
  justifyContent: 'center',
  alignItems: 'center',   
  flexDirection: 'column', 
  position: 'relative',
  zIndex: 1000
}

const thumbInner = {
  display: 'flex',
  minWidth: 0,
}



class Application extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      files: [],   

      alert: false,
      alertContents: "",   
      alertStatus: false
    };

    this.handleModal = this.handleModal.bind(this);
  }

  handleModal = (value) => (event) => {
    this.setState({ modal: value })
  }

  submitApplicationUpdate = () => {

    const { storage, order, setState, state, fetchData } = this.props;
    const { language } = storage;
    const t = Lang[language];

    const files = [...this.state.files]


    var formData  = new FormData();

    files.forEach( file => formData.append('files', file ) );
    formData.append('id', order._id);

    this.setState({ modal: false })

    const h = this.context.router.history;
    formDataSubmit(h)(
      formData,
      `${BASE_URL}/api/v1/applications/update/assets`,
      () => setState({ 'loading.update': true }),
      data => { 
        if (data.validationErrors){
          setState({ 
            alert: true,
            alertStatus: "danger",
            alertContents: data.validationErrors.map(e => e.msg).reduce((acc, cur) => { return `${acc}\n${cur}`}, "")
          })    
        } else if (data.err) {
          setState({ 
            alert: true,
            alertStatus: "danger",
            alertContents: data.err
          })    
        } else if (!data.output){
          setState({ 
            alert: true,
            alertStatus: "danger",
            alertContents: t['application.update.message.unknown_error']
          })             
        } else {
          setState({ 
            alert: true,
            alertStatus: "success",
            alertContents: t['application.update.message.success'],
            // order: data.output
          })               
          fetchData();
        }
      },
      e => {
        console.log(e);
        setState({ 
          alert: true,
          alertStatus: "danger",
          alertContents: e
        })          
      },
      () => { 
        setState({ 'loading.update': false }) 
      },
    ) 
  }

  render(){

    const { classes, organizations, order, match, error, storage, fetchData } = this.props;
    const { language } = storage;
    const t = Lang[language];    


    console.log(order);

    if (error == 400){
      return (
        <Card className="container" style={{ width: "90%", "textAlign": "left", padding: "50px 55px", }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400, color: "#28429e", flexDirection: 'column' }}>

            <i className="fa fa-ghost" style={{ color: "#28429e", fontSize: 150 }}/>

            <Typography style={{ fontSize: 40, color: "#28429e",  textTransform: "uppercase", paddingBottom: 5, margin: 0, paddingTop: 40 }} gutterBottom >
              {t['application.error.not_found']}
            </Typography>     
            <Typography style={{ fontSize: 16, color: "#28429e", paddingBottom: 35, margin: 0 }} gutterBottom >
              {t['application.error.application']} {match.params.id} {t['application.error.is_not_available']}
            </Typography>                        
          </div>
        </Card>
      )
    } else if (error) {
      return (
        <Card className="container" style={{ width: "90%", "textAlign": "left", padding: "50px 55px", }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400, color: "#28429e", flexDirection: 'column' }}>

            <i className="fa fa-times" style={{ color: "#28429e", fontSize: 150 }}/>

            <Typography style={{ fontSize: 40, color: "#28429e",  textTransform: "uppercase", paddingBottom: 5, margin: 0, paddingTop: 40 }} gutterBottom >
              {t['application.error.unknown']}
            </Typography>    
            <Typography style={{ fontSize: 16, color: "#28429e", paddingBottom: 35, margin: 0 }} gutterBottom >
              {t['application.error.contact_support']}
            </Typography>                        
          </div>
        </Card>
      )
    }


    let statusColor;
    let statusText;
    if (order.status === undefined){
      statusColor = "#fed713";
      statusText = t['dashboard.application.waiting_for_approval'];      
    } else if (!order.status){
      statusColor = "#fe7c96";
      statusText = t['dashboard.application.rejected'];       
    } else if (order.status && !order.paymentAt){
      statusColor = "#fed713";
      statusText = t['dashboard.application.unpaid']; 
    } else if (order.status && order.terminatedAt){
      statusColor = "#fe7c96";
      statusText = "Terminated";        
    } else if (order.status && moment().isAfter(order.end_date) ){
      statusColor = "#ccc";
      statusText = t['dashboard.application.expired']; 
    } else {
      statusColor = "#1bcfb4";
      statusText = t['dashboard.application.paid'];       
    }


    const thumbs = order.assets && order.assets.map(file => {

      return <div style={{
        display: 'inline-flex',
        borderRadius: 2,
        border: '1px solid #eaeaea',
        marginBottom: 8,
        marginRight: 8,
        width: 60,
        height: 60,
        padding: 4,
        boxSizing: 'border-box',
        justifyContent: 'center',
        alignItems: 'center',   
        flexDirection: 'column', 
        position: 'relative',
        zIndex: 1000,
        cursor: 'pointer'
      }} 
        onClick={ () => window.open(`${BASE_URL}/assets/${file.filename}`, '_blank') }
        key={file._id+Math.random()}>

        { file.mimetype.includes("image") ?
          <div style={thumbInner}>
            <i className="far fa-file-image fa-2x" style={{ color: '#ddd'}} />
          </div>
        : file.mimetype.includes("pdf") ?
          <div style={thumbInner}>
            <i className="far fa-file-pdf fa-2x" style={{ color: '#ddd'}} />
          </div>
        :
          <div style={thumbInner}>
            <i className="far fa-file fa-2x" style={{ color: '#ddd'}} />
          </div>        
        }      
        
        <div style={{ width: 60, position: 'absolute', bottom: 5, left: 0, right: 0, textAlign: 'center' }}>
          <p style={{ fontSize: 10, margin: 0, overflow: "hidden", "textOverflow": "ellipsis", overflow: 'hidden', lineHeight: 1, }}>{file.originalname}</p>
        </div>

      </div>
    })    


    return (
      <Card className="container" style={{ width: "90%", "textAlign": "left", padding: "50px 55px", }}>

        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.modal}
          onClose={this.handleModal(false)}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className={classes.paper}>
            <Typography style={{ fontSize: 30, color: "#28429e", textAlign: 'center', textTransform: "uppercase", margin: "40px 0px" }} gutterBottom >
                  {t['form.upload.title']}
            </Typography> 

            <Preview setState={this.setState.bind(this)} state={this.state} t={t} /> 

            <div style={{ "justifyContent": "flex-end", display: "flex" }}>
              <Button onClick={this.submitApplicationUpdate}
                type="submit" size="large" variant="contained" color="primary" style={{ fontSize: 20, margin: "50px 10px", padding: "5px 120px", "textTransform": "none", "borderRadius": "2px" }} >
                {t['form.submit.title']}
              </Button>
            </div>

          </div>
        </Modal>

      { this.props.loading ? 
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400, color: "#28429e", }}>
          <i className="fas fa-spinner fa-10x fa-pulse"></i>
        </div> : Object.keys(order).length > 0 ?

        <div>
          <div style={{ display: 'flex' }}>


            <div style={{ width: '65%' }}>

              <div style={{  width: '100%', padding: "4px 0", display: 'flex', marginBottom: 0 }}>
                <Typography style={{ fontSize: 16, width: '50%',  textTransform: "uppercase", fontWeight: 'bold' }} gutterBottom >
                  {t['confirm.application.title']} {order._id}
                </Typography>           
              </div>   

              <div style={{  width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9, alignItems: 'center' }}>
                <span style={{ paddingRight: "5px" }}>{t['confirm.status.title']}: </span>
                <i className="fa fa-circle" style={{ color: statusColor, fontSize: 10 }}/>
                <span style={{ paddingLeft: "5px" }}>{statusText}</span>
              </div>    

              <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                  {t['confirm.summary.project_number']}
                </Typography>  
                <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                  { order.contract.project_number }
                </Typography>              
              </div>   

              <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                  {t['confirm.summary.contractor']}
                </Typography>  
                <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                  { order.contractor.name }
                </Typography>              
              </div>     

              <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                  {t['confirm.summary.sum']}
                </Typography>  
                <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                  { order.contract.sum.replace(/(.)(?=(.{3})+$)/g,"$1 ") }
                </Typography>              
              </div>                        

              { order.type === "Fullgörande" &&
                <div>
                  <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                    <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                      {t['confirm.summary.while_contract.type']}
                    </Typography>  
                    <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                      <i className="fas fa-flag" style={{ color: '#28429e'}} /> {t['confirm.summary.while_contract.type_name']}
                    </Typography>              
                  </div>   

                  <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                    <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                      {t['confirm.summary.while_contract.start_date']}
                    </Typography>  
                    <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                      { moment(order.start_date).format("YYYY-MM-DD") }
                    </Typography>              
                  </div>     

                  <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                    <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                      {t['confirm.summary.while_contract.end_date']}
                    </Typography>  
                    <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                      { moment(order.end_date).format("YYYY-MM-DD") }
                    </Typography>              
                  </div>   

                  <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                    <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                      {t['confirm.summary.while_contract.amount']}
                    </Typography>  
                    <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                      { order.amount }% {t['confirm.summary.while_contract.of_sum']}
                    </Typography>              
                  </div>     

                </div>
              }   

              { order.type === "Garantitid" &&
                <div>
                  <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                    <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                      {t['confirm.summary.while_warranty.type']}
                    </Typography>  
                    <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                      <i className="fas fa-flag" style={{ color: '#28429e'}} /> {t['confirm.summary.while_warranty.type_name']}
                    </Typography>              
                  </div>   

                  <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                    <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                      {t['confirm.summary.while_warranty.start_date']}
                    </Typography>  
                    <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                      { moment(order.start_date).format("YYYY-MM-DD") }
                    </Typography>              
                  </div>     

                  <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                    <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                      {t['confirm.summary.while_warranty.end_date']}
                    </Typography>  
                    <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                      { moment(order.end_date).format("YYYY-MM-DD") }
                    </Typography>              
                  </div>   

                  <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                    <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                      {t['confirm.summary.while_warranty.amount']}
                    </Typography>  
                    <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                      { order.amount }% {t['confirm.summary.while_warranty.of_sum']}
                    </Typography>              
                  </div>




                </div>
              }            

              <div style={{ width: '100%', padding: "4px 0", marginBottom: 9 }}>
                <Typography style={{ fontSize: 16, width: '100%' }} gutterBottom >
                  {t['application.attachments.title']}
                </Typography>  
                <div style={{ fontSize: 16, width: '100%', display: 'flex' }} >

                  { thumbs && thumbs.length 
                    ? 
                    <div>
                      {thumbs}
                    </div>
                    :
                    <div>
                      <p style={{ fontSize: 12 }}>{t['application.attachments.no_selected.title']}</p>
                    </div>          
                  } 
              


                </div>     
                  <button onClick={this.handleModal(true)} style={{ fontSize: 20, margin: "0px", padding: "10px", "textTransform": "none", "borderRadius": "2px", width: 60, height: 60, }} >
                    <i className="fa fa-plus" style={{ color: "#28429e", fontSize: 40 }}/>
                  </button>                              
              </div>           

            </div>



          </div>

          { order.policy &&
            <div style={{ display: 'flex' }}>
              <div style={{ width: '50%' }}>
                <Button onClick={ () => window.open(order.policy.url, '_blank') } size="large" variant="contained" color="primary" style={{ fontSize: 20, margin: "30px 0px", padding: "5px 100px", "textTransform": "none", "borderRadius": "2px" }} >
                  {t['application.submit.download_policy']}
                </Button>              
              </div>  
            </div>   
          }
        </div> : null         
      }
      </Card> )

    }
};


Application.contextTypes = {
  router: PropTypes.object.isRequired
};


const mapStateToProps = (state) => {
  return {
    storage: state.storage,
  };
};
const mapDispatchToProps = (dispatch) => ({
  
});

export default connect(  
  mapStateToProps,
  mapDispatchToProps)
(withStyles(styles)(Application));